<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedWorkerAccounts"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Workers')"
      :list="workerAccounts"
      :placeholder="$t('Select workers to filter by')"
      max-labels-visible="5"
      can-deselect
      labels-primary
    >
      <template #select-all-text>
        <WdsText :text="$t('Select all')" />
      </template>
    </WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { computed, ComputedRef, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { ListItem } from '@/components/Workflows/Pages/Workflow/workflow'
import { useAccountsStore } from '@/components/GraphqlDataTable/filters/accounts/accounts-store'
import { graphql } from '@/gql'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

type WorkerAccountFilter = ListItem & { id: string }

defineProps<{ meta: FilterMetaDataProp }>()

const selectedWorkerAccounts: ModelRef<WorkerAccountFilter[]> = defineModel({
  default: () => [],
})

const { selectedAccounts } = useAccountsStore()

const { result } = useQuery(
  graphql(`
    query WorkerHires($accounts: [ID!]) {
      hires(accounts: $accounts, first: 100000) {
        data {
          worker {
            id
            # Support for list item
            value: id
            label: name
          }
        }
      }
    }
  `),
  () => ({
    accounts: selectedAccounts.map((account) => account.id),
  }),
  {
    clientId: 'publicApiCustomFields',
  },
)

const workerAccounts: ComputedRef<WorkerAccountFilter[]> = computed(() => [
  ...new Set(result.value?.hires.data.map(({ worker }) => worker) ?? []),
])
</script>
